import { DownloadIcon } from "assets/icons";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "ui";

import { downloadReturnPdf } from "../../../../helpers";
import { ReturnModalAtomProps } from "../ReturnModal.types";

export const DownloadDetailsBtn = ({ returnDetails }: ReturnModalAtomProps) => {
  return (
    <div>
      <QRCodeCanvas
        value={returnDetails.id}
        id={`qr-${returnDetails.id}`}
        style={{ display: "none" }}
      />

      <Button
        type="button"
        title={"Download QR & Details Sheet"}
        icon={<DownloadIcon width={24} height={24} />}
        variant="default"
        onClick={() => downloadReturnPdf([returnDetails])}
      />
    </div>
  );
};
